export default __webpack_public_path__ + "static/media/BLR6.c05ceafc.jpg";